import { AgencyPoliciesFilterOptionsEnum } from "../../../dtos/agency-policies-filter-options-enum";
import { SelectOptions } from "../../../dtos/select-options";
import { FromEnumToArray } from "../../../utilities/enumFunctions";
import { BaseGridColumnOptionsProperties } from "../../BaseGrid/BaseGridProperties";

export const agencyPolicyFilterOptions:
  | Partial<SelectOptions>[]
  | SelectOptions[] = FromEnumToArray(AgencyPoliciesFilterOptionsEnum).map(
  (option) => {
    return {
      displayName: option.key,
      intValue: option.value,
    };
  }
);

export const tableColumnOptions: BaseGridColumnOptionsProperties<any>[] | null =
  [
    { fieldName: "Line", width: 4 },
    { fieldName: "PolicyNumber", width: 10 },
    { fieldName: "InsuredCode", width: 10 },
    { fieldName: "InsuredName", width: 12 },
    { fieldName: "PolicyDates", width: 12 },
    { fieldName: "AgencyLocation", width: 14 },
    { fieldName: "AgencyContact", width: 14 },
    { fieldName: "PolicyStatus", width: 5 },
    { fieldName: "EstimatedAnnualPremium", width: 8, align: "right" },
    { fieldName: "PaidToDate", width: 8, align: "right" },
    { fieldName: "OPTIONS", width: 3 },
  ];

export const toolbarOptions = {
  showAddButton: false,
  showEditButton: false,
  showSaveButton: false,
  showImportButton: false,
  showSortFilter: false,
};
